import { render, staticRenderFns } from "./InsertMenu.vue?vue&type=template&id=71b303a0&"
import script from "./InsertMenu.vue?vue&type=script&lang=js&"
export * from "./InsertMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports